export const OverlayComponent = {
  components: {
    Overlay: {
      baseStyle: {
        position: 'fixed',
        left: 0,
        top: 0,
        width: '100vw',
        height: '100vh',
        background: 'blackAlpha.600',
        zIndex: 'overlay'
      }
    }
  }
}
